// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PcM2","left":"styles_left__1aKu_","desktopActions":"styles_desktopActions__27PHA","title":"styles_title__3N8M9"};